import { inject, Injector } from '@angular/core';
import type { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { RedirectCommand, Router } from '@angular/router';
import { map } from 'rxjs';
import type { RouteConfig } from '../../../../common/interfaces/address/calculate-route-request';
import type { TelematicsRoutePoint } from '../../../../common/interfaces/telematics/telematics-route-point';
import type { VehicleCategory } from '../../../fleet/common/constants/vehicle-categories';
import type { Fleet } from '../../../fleet/common/interfaces/fleet';
import { OrderFormRouteConfigModalComponent } from '../../order-form/order-form-route/order-form-route-config-modal/order-form-route-config-modal.component';
import { OrdersRoute } from '../enums/orders-route';
import { OrdersRouterStateKey } from '../enums/orders-router-state-key';
import type { Order } from '../interfaces/order';

export interface OrderManualRouteResolverData {
  [OrdersRouterStateKey.ORDER]: Order;
  [OrdersRouterStateKey.FLEET]: Fleet;
  [OrdersRouterStateKey.FLEET_ROUTE]: TelematicsRoutePoint[];
  [OrdersRouterStateKey.ROUTE_CONFIG]: RouteConfig;
}

export const orderManualRouteResolver: ResolveFn<
  OrderManualRouteResolverData
> = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const injector = inject(Injector);

  const state = router.currentNavigation()?.extras?.state;
  const order: Order = state?.[OrdersRouterStateKey.ORDER];
  const fleet: Fleet = state?.[OrdersRouterStateKey.FLEET];
  const fleetRoute: TelematicsRoutePoint[] =
    state?.[OrdersRouterStateKey.FLEET_ROUTE];

  if (!order || !fleet || !fleetRoute) {
    const uuid = route.paramMap.get('uuid');
    const urlTree = router.parseUrl(
      OrdersRoute.ORDER_CARD.replace(':uuid', uuid!),
    );
    return new RedirectCommand(urlTree, { replaceUrl: true });
  }

  const routeConfig$ = OrderFormRouteConfigModalComponent.getDefaultConfig(
    injector,
    {
      vehicleCategory: fleet.generalInformation.category as VehicleCategory,
      vehicleTypes: [fleet.generalInformation.type!],
    },
  );

  return routeConfig$.pipe(
    map((routeConfig) => ({
      order,
      fleet,
      fleetRoute,
      routeConfig,
    })),
  );
};
